import type { Moment } from 'moment';
import moment from 'moment';

export type AnyDate = string | Date | Moment;
export const STANDARD_DATE_FORMAT = 'L';
export const STANDARD_TIME_FORMAT = 'LT';
export const HUMAN_READABLE_DATE_FORMAT = 'LL';
export const HUMAN_READABLE_DATE_TIME_FORMAT = 'LLL';

export const formatDate = (date: AnyDate): string =>
  date ? moment(date).format(STANDARD_DATE_FORMAT) : date;

export const formatTime = (date: AnyDate): string =>
  date ? moment(date).format(STANDARD_TIME_FORMAT) : date;

export const formatDateTime = (date: AnyDate) => (date ? moment(date).calendar() : date);

export const formatDateForAPI = (date: AnyDate): string =>
  date ? moment(date).format('YYYY-MM-DD') : date;

export const formatDateHumanReadable = (date: AnyDate): string =>
  date ? moment(date).format(HUMAN_READABLE_DATE_FORMAT) : date;

export const formatDateTimeHumanReadable = (date: AnyDate): string =>
  date ? moment(date).format(HUMAN_READABLE_DATE_TIME_FORMAT) : date;

export const formatTimeZone = (date: AnyDate): string => `GMT${moment(date).format('Z')}`;
